import { getLocalStorage } from '../utilities/LocalStorage';

export default function useVendor() {
	return getLocalStorage('vendorData', true) || {};
}
